import axios from 'axios';
import { FACTURA } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

const ENDPOINT_CATEGORIAS = '/configuracion/listar_categorias';
const ENDPOINT_SUBCATEGORIAS = '/configuracion/listar_subcategorias';
const ENDPOINT_PRODUCTOS = '/configuracion/listar_productos';

const ENDPOINT_CREAR_PRODUCTO = '/facturas/crear_producto';
const ENDPOINT_CREAR_PRODUCTO_PROVEEDOR = '/facturas/crear_producto_proveedor';
const ENDPOINT_ELIMINAR = '/facturas/eliminar';
const ENDPOINT_DEVOLVER = '/facturas/devolver';

// Helpers
const buildFormBody = (filtros = {}) => {
  const params = new URLSearchParams();

  // ✅ La ruta acepta SIEMPRE: id_proveedor, fecha_inicio, fecha_fin (aunque sea vacío)
  params.append('id_proveedor', filtros?.id_proveedor ?? '');
  params.append('fecha_inicio', filtros?.fecha_inicio ?? '');
  params.append('fecha_fin', filtros?.fecha_fin ?? '');

  return params;
};

const formData = (obj) => {
    const params = new URLSearchParams();
    Object.keys(obj).forEach((k) => {
        const v = obj[k];
        params.append(k, v === null || v === undefined ? '' : v);
    });
    return params;
};

export const buscarFacturas = (filtros = {}) => async dispatch => {
  const config = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };

  try {
    await dispatch(changeLoader(true));

    const body = buildFormBody(filtros);
    const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/facturas/listar`, body, config);

    await dispatch({
      type: FACTURA.BUSCAR,
      payload: res.data,
    });

    await dispatch(changeLoader(false));
  } catch (err) {
    await dispatch(changeLoader(false));

    await dispatch({
      type: FACTURA.ERROR,
      payload: err?.response?.data || { msg: err.message },
    });

    dispatch(setAlert(err?.response?.data?.msg || 'Error al consultar facturas', 'danger'));
  }
};

export const filtrarFacturas = (texto = '') => async dispatch => {
  dispatch({
    type: FACTURA.FILTRAR,
    payload: texto,
  });
};

export const limpiarFacturas = () => async dispatch => {
  dispatch({ type: FACTURA.LIMPIAR });
};

export const setFiltrosFacturas = (filtros = {}) => async dispatch => {
  dispatch({
    type: FACTURA.SET_FILTROS,
    payload: filtros,
  });
};

export const limpiarFiltrosFacturas = () => async dispatch => {
  dispatch({ type: FACTURA.LIMPIAR_FILTROS });
};

// ===========================
// ✅ NUEVO: Detalles factura
// ===========================
export const buscarFacturaDetalle = (id) => async dispatch => {
  const config = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };

  try {
    await dispatch(changeLoader(true));

    const params = new URLSearchParams();
    params.append('id', id ?? '');

    const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/facturas/detalles`, params, config);

    await dispatch({
      type: FACTURA.DETALLE,
      payload: res.data, // esperamos { factura: {...} }
    });

    await dispatch(changeLoader(false));
  } catch (err) {
    await dispatch(changeLoader(false));

    await dispatch({
      type: FACTURA.ERROR,
      payload: err?.response?.data || { msg: err.message },
    });

    dispatch(setAlert(err?.response?.data?.msg || 'Error al consultar detalles de la factura', 'danger'));
  }
};

export const limpiarFacturaDetalle = () => async dispatch => {
  dispatch({ type: FACTURA.LIMPIAR_DETALLE });
};

// ===========================
// Crear factura
// ===========================
export const crearFactura = (data) => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    try {
        await dispatch(changeLoader(true));

        const moneda = Number(data?.moneda) === 1 ? 1 : 0;
        const tcRaw = Number(data?.tipo_cambio);
        const tipoCambio = moneda === 1 && tcRaw > 0 ? tcRaw : 1;

        const conv = (v) => {
            if (v === null || v === undefined || v === '') return '';
            const x = Number(v);
            if (Number.isNaN(x)) return '';
            const y = moneda === 1 ? (x * tipoCambio) : x;
            return (Math.round(y * 100) / 100).toString();
        };

        const params = new URLSearchParams();

        params.append('id_proveedor', data?.id_proveedor ?? '');
        params.append('id_metodo', data?.id_metodo ?? '');
        params.append('numero', data?.numero ?? '');
        params.append('monto_real', conv(data?.monto_real ?? ''));
        params.append('fecha', data?.fecha ?? '');
        params.append('moneda', String(moneda));
        params.append('tipo_cambio', String(tipoCambio));

        (data.productos || []).forEach((p, idx) => {
            params.append(`productos[${idx}][_id]`, p?._id ?? '');
            params.append(`productos[${idx}][codigo_tienda]`, p?.codigo_tienda ?? p?.codigo_inra ?? '');
            params.append(`productos[${idx}][codigo_proveedor]`, p?.codigo_proveedor ?? '');
            params.append(`productos[${idx}][cantidad_surtir]`, (p?.cantidad_surtir ?? '').toString());
            params.append(`productos[${idx}][precio_unitario]`, conv(p?.precio_unitario ?? p?.precio ?? ''));
            params.append(`productos[${idx}][precio_publico]`, conv(p?.precio_publico ?? ''));
            params.append(`productos[${idx}][precio_minimo]`, conv(p?.precio_minimo ?? ''));
            params.append(`productos[${idx}][precio_liquidacion]`, conv(p?.precio_liquidacion ?? ''));
            params.append(`productos[${idx}][impuestos]`, (p?.impuestos ?? 0).toString());
            params.append(`productos[${idx}][unidad]`, p?.unidad ?? '');
        });

        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/facturas/crear`, params, config);

        await dispatch({
            type: FACTURA.CREAR,
            payload: res.data
        });

        dispatch(setAlert(res?.data?.msg || 'Factura creada correctamente', 'success'));
        await dispatch(changeLoader(false));
        return true;
    } catch (err) {
        await dispatch(changeLoader(false));

        await dispatch({
            type: FACTURA.CREAR_ERROR,
            payload: err?.response?.data || { msg: err.message },
        });

        dispatch(setAlert(err?.response?.data?.msg || 'Error al crear factura', 'danger'));
        return false;
    }
};


// ===========================
// Editar factura
// ===========================
export const editarFactura = (data) => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    try {
        await dispatch(changeLoader(true));

        const moneda = Number(data?.moneda) === 1 ? 1 : 0;
        const tcRaw = Number(data?.tipo_cambio);
        const tipoCambio = moneda === 1 && tcRaw > 0 ? tcRaw : 1;

        const conv = (v) => {
            if (v === null || v === undefined || v === '') return '';
            const x = Number(v);
            if (Number.isNaN(x)) return '';
            const y = moneda === 1 ? (x * tipoCambio) : x;
            return (Math.round(y * 100) / 100).toString();
        };

        const params = new URLSearchParams();

        params.append('id', data?.id ?? '');
        params.append('id_proveedor', data?.id_proveedor ?? '');
        params.append('id_metodo', data?.id_metodo ?? '');
        params.append('numero', data?.numero ?? '');
        params.append('monto_real', conv(data?.monto_real ?? ''));
        params.append('fecha', data?.fecha ?? '');
        params.append('moneda', String(moneda));
        params.append('tipo_cambio', String(tipoCambio));

        (data.productos || []).forEach((p, idx) => {
            params.append(`productos[${idx}][_id]`, p?._id ?? '');
            params.append(`productos[${idx}][codigo_tienda]`, p?.codigo_tienda ?? p?.codigo_inra ?? '');
            params.append(`productos[${idx}][codigo_proveedor]`, p?.codigo_proveedor ?? '');
            params.append(`productos[${idx}][cantidad_surtir]`, (p?.cantidad_surtir ?? '').toString());
            params.append(`productos[${idx}][precio_unitario]`, conv(p?.precio_unitario ?? p?.precio ?? ''));
            params.append(`productos[${idx}][precio_publico]`, conv(p?.precio_publico ?? ''));
            params.append(`productos[${idx}][precio_minimo]`, conv(p?.precio_minimo ?? ''));
            params.append(`productos[${idx}][precio_liquidacion]`, conv(p?.precio_liquidacion ?? ''));
            params.append(`productos[${idx}][impuestos]`, (p?.impuestos ?? 0).toString());
            params.append(`productos[${idx}][unidad]`, p?.unidad ?? '');
        });

        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/facturas/editar`, params, config);

        await dispatch({
            type: FACTURA.EDITAR,
            payload: res.data
        });

        dispatch(setAlert(res?.data?.msg || 'Factura editada correctamente', 'success'));
        await dispatch(changeLoader(false));
        return true;
    } catch (err) {
        await dispatch(changeLoader(false));

        await dispatch({
            type: FACTURA.EDITAR_ERROR,
            payload: err?.response?.data || { msg: err.message },
        });

        dispatch(setAlert(err?.response?.data?.msg || 'Error al editar factura', 'danger'));
        return false;
    }
};


export const cargarCategoriasFactura = () => async (dispatch) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}${ENDPOINT_CATEGORIAS}`);
        const listado = res?.data?.listado || res?.data?.categorias || res?.data || [];

        dispatch({
            type: FACTURA.CATEGORIAS_CARGADAS,
            payload: Array.isArray(listado) ? listado : []
        });

        return true;
    } catch (e) {
        dispatch(setAlert('No se pudieron cargar categorías', 'danger'));
        dispatch({ type: FACTURA.CATEGORIAS_CARGADAS, payload: [] });
        return false;
    }
};

export const cargarSubcategoriasFactura = (id_categoria) => async (dispatch) => {
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_SUBCATEGORIAS}`,
            formData({ id: id_categoria }),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        const listado = res?.data?.listado || res?.data?.subcategorias || res?.data || [];

        dispatch({
            type: FACTURA.SUBCATEGORIAS_CARGADAS,
            payload: Array.isArray(listado) ? listado : []
        });

        return true;
    } catch (e) {
        dispatch({ type: FACTURA.SUBCATEGORIAS_CARGADAS, payload: [] });
        return false;
    }
};

export const cargarProductosFactura = (data) => async (dispatch) => {
    try {
        const body = JSON.stringify({
            id_proveedor: data?.id_proveedor ?? null,
            id_categoria: data?.id_categoria ?? null,
            id_subcategoria: data?.id_subcategoria ?? null,
            nombre: data?.nombre ?? null,
            codigo: data?.codigo ?? null,
            tipo: 1,
            codigo_proveedor: data?.codigo_proveedor ?? null
        });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_productos`,
            body,
            config
        );

        dispatch({
            type: FACTURA.PRODUCTOS_CARGADOS,
            payload: res.data?.productos || []
        });

        return true;
    } catch (err) {
        dispatch(setAlert('No se pudieron cargar los productos', 'danger'));
        dispatch({ type: FACTURA.ERROR });
        return false;
    }
};

export const obtenerCodigoProductoFactura = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.get(
      `${process.env.REACT_APP_API_ROUTE}/facturas/codigo_producto`,
      config
    );

    if (res.data?.success && res.data?.codigo) {
      dispatch({ type: FACTURA.CODIGO_PRODUCTO_CARGADO, payload: res.data.codigo });
      return res.data.codigo;
    }

    dispatch(setAlert('No se pudo obtener el código del producto', 'danger'));
    return '';
  } catch (err) {
    dispatch(setAlert('No se pudo obtener el código del producto', 'danger'));
    return '';
  }
};

export const cargarSubcategoriasNuevoProductoFactura = (id_categoria) => async (dispatch) => {
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_SUBCATEGORIAS}`,
            formData({ id: id_categoria }),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        const listado = res?.data?.listado || res?.data?.subcategorias || res?.data || [];

        dispatch({
            type: FACTURA.SUBCATEGORIAS_NUEVO_PRODUCTO_CARGADAS,
            payload: Array.isArray(listado) ? listado : []
        });

        return true;
    } catch (e) {
        dispatch({ type: FACTURA.SUBCATEGORIAS_NUEVO_PRODUCTO_CARGADAS, payload: [] });
        return false;
    }
};

export const crearProductoCatalogoFactura = ({ id_categoria, id_subcategoria, nombre, codigo_tienda, descripcion, unidades }) => async (dispatch, getState) => {
    try {
        const config = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        };

        const params = new URLSearchParams();
        params.append('id_categoria', id_categoria ? String(id_categoria) : '');
        params.append('id_subcategoria', id_subcategoria ? String(id_subcategoria) : '');
        params.append('nombre', nombre ? String(nombre) : '');
        params.append('codigo_tienda', codigo_tienda ? String(codigo_tienda) : '');
        params.append('descripcion', descripcion ? String(descripcion) : '');

        const unidadesArr = Array.isArray(unidades) ? unidades : [];
        for (let i = 0; i < unidadesArr.length; i++) {
            params.append(`unidades[${i}][id_unidad]`, unidadesArr[i]?.id_unidad ? String(unidadesArr[i].id_unidad) : '');
            params.append(`unidades[${i}][tipo]`, unidadesArr[i]?.tipo !== null && unidadesArr[i]?.tipo !== undefined ? String(unidadesArr[i].tipo) : '');
            params.append(`unidades[${i}][cantidad]`, unidadesArr[i]?.cantidad !== null && unidadesArr[i]?.cantidad !== undefined ? String(unidadesArr[i].cantidad) : '');
        }

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_CREAR_PRODUCTO}`,
            params.toString(),
            config
        );

        let producto =
            res?.data?.producto ||
            res?.data?.data ||
            res?.data?.result ||
            null;

        if (producto && Array.isArray(producto.unidades)) {
            const listadoUnidades = getState()?.configuracion?.unidades?.listado || [];
            const mapUnidades = new Map((listadoUnidades || []).map((u) => [String(u._id), u?.nombre || '']));

            producto = {
                ...producto,
                unidades: producto.unidades.map((u) => {
                    if (u?.unidad?._id) return u;

                    const id = u?.id_unidad ? String(u.id_unidad) : '';
                    const nombreUnidad = id ? (mapUnidades.get(id) || '') : '';

                    return {
                        ...u,
                        unidad: id ? { _id: id, nombre: nombreUnidad } : u?.unidad
                    };
                })
            };
        }

        if (!producto?._id) {
            dispatch(setAlert(res?.data?.msg || 'No se pudo crear el producto', 'danger'));
            return null;
        }

        dispatch({
            type: FACTURA.PRODUCTO_CREADO,
            payload: producto
        });

        dispatch(setAlert(res?.data?.msg || 'Producto creado correctamente', 'success'));

        return producto;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.msg || 'Error al crear producto', 'danger'));
        return null;
    }
};


export const crearProductoProveedorFactura = ({ id_producto, id_proveedor, codigo_proveedor, precio_unitario, precio_publico, precio_minimo, precio_liquidacion }) => async (dispatch) => {
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_CREAR_PRODUCTO_PROVEEDOR}`,
            formData({
                id_producto,
                id_proveedor,
                codigo_proveedor,
                precio_unitario,
                precio_publico,
                precio_minimo,
                precio_liquidacion
            }),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (!res?.data?.success) {
            dispatch(setAlert(res?.data?.msg || 'No se pudo agregar el producto al proveedor', 'danger'));
            return false;
        }

        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.msg || 'Error al agregar producto al proveedor', 'danger'));
        return false;
    }
};

export const limpiarCodigoProductoFactura = () => (dispatch) => {
    dispatch({ type: FACTURA.LIMPIAR_CODIGO_PRODUCTO });
};

export const limpiarCatalogosFactura = () => (dispatch) => {
    dispatch({ type: FACTURA.LIMPIAR_CATALOGOS });
};

export const eliminarFactura = (id) => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));

        const params = new URLSearchParams();
        params.append('id', id);

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_ELIMINAR}`,
            params,
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        await dispatch({
            type: FACTURA.ELIMINAR,
            payload: { id }
        });

        dispatch(setAlert(res?.data?.msg || 'Factura eliminada correctamente', 'success'));
        await dispatch(changeLoader(false));
        return true;
    } catch (err) {
        await dispatch(changeLoader(false));

        await dispatch({
            type: FACTURA.ELIMINAR_ERROR,
            payload: err?.response?.data || { msg: err.message },
        });

        dispatch(setAlert(err?.response?.data?.msg || 'Error al eliminar la factura', 'danger'));
        return false;
    }
};

export const devolverFactura = (id) => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));

        const params = new URLSearchParams();
        params.append('id', id);

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}${ENDPOINT_DEVOLVER}`,
            params,
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (!res?.data?.success) {
            dispatch(setAlert(res?.data?.msg || 'No se pudo devolver la factura', 'danger'));
            await dispatch(changeLoader(false));
            return false;
        }

        await dispatch({
            type: FACTURA.DEVOLVER,
            payload: { id }
        });

        dispatch(setAlert(res?.data?.msg || 'Factura devuelta correctamente', 'success'));
        await dispatch(changeLoader(false));
        return true;
    } catch (err) {
        await dispatch(changeLoader(false));

        await dispatch({
            type: FACTURA.DEVOLVER_ERROR,
            payload: err?.response?.data || { msg: err.message },
        });

        dispatch(setAlert(err?.response?.data?.msg || 'Error al devolver la factura', 'danger'));
        return false;
    }
};

export const cargarDetalleDevolucionFactura = (idFactura) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = new URLSearchParams();
    body.append('id', idFactura);

    try {
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/facturas/detalles`,
            body.toString(),
            config
        );

        await dispatch({
            type: FACTURA.DETALLE_DEVOLUCION,
            payload: res.data?.factura || null
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({
            type: FACTURA.ERROR
        });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalles de factura', 'danger'));
        return false;
    }
};

export const limpiarDetalleDevolucionFactura = () => (dispatch) => {
    dispatch({
        type: FACTURA.LIMPIAR_DETALLE_DEVOLUCION
    });
};

export const devolverFacturaParcial = (data) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = new URLSearchParams();
    body.append('id', data?.id || '');
    body.append('id_metodo', data?.id_metodo ? String(data.id_metodo) : '');
    body.append('monto_real', String(data?.monto_real ?? 0));

    const productos = Array.isArray(data?.productos) ? data.productos : [];
    for (let i = 0; i < productos.length; i++) {
        body.append(`productos[${i}][_id]`, productos[i]?._id ? String(productos[i]._id) : '');

        const ubicaciones = Array.isArray(productos[i]?.ubicaciones) ? productos[i].ubicaciones : [];
        for (let j = 0; j < ubicaciones.length; j++) {
            body.append(`productos[${i}][ubicaciones][${j}][area]`, ubicaciones[j]?.area ? String(ubicaciones[j].area) : '');
            body.append(`productos[${i}][ubicaciones][${j}][organizador]`, ubicaciones[j]?.organizador ? String(ubicaciones[j].organizador) : '');
            body.append(`productos[${i}][ubicaciones][${j}][ubicacion]`, ubicaciones[j]?.ubicacion ? String(ubicaciones[j].ubicacion) : '');
            body.append(`productos[${i}][ubicaciones][${j}][cantidad]`, String(ubicaciones[j]?.cantidad ?? 0));
        }
    }

    try {
        await dispatch(changeLoader(true));

        await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/facturas/devolver_parcial`,
            body.toString(),
            config
        );

        await dispatch({
            type: FACTURA.DEVOLVER_PARCIAL,
            payload: {
                id: data?.id || '',
                monto_real: data?.monto_real ?? 0
            }
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({
            type: FACTURA.DEVOLVER_PARCIAL_ERROR
        });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al aplicar devolución parcial', 'danger'));
        return false;
    }
};
